import { render, staticRenderFns } from "./MemberGroupReview.vue?vue&type=template&id=7a83f2ea&"
import script from "./MemberGroupReview.vue?vue&type=script&lang=js&"
export * from "./MemberGroupReview.vue?vue&type=script&lang=js&"
import style0 from "./MemberGroupReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MemberGroupReview.vue"
export default component.exports